import * as React from 'react'
import { cn } from '@/lib/utils'

const checkboxVariants =
  'h-4 w-4 shrink-0 rounded border-[var(--fl-border)] accent-[var(--fl-heading)] cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fl-heading)]/20 disabled:opacity-50 disabled:cursor-not-allowed'

export type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => {
    return (
      <input ref={ref} type="checkbox" className={cn(checkboxVariants, className)} {...props} />
    )
  }
)
Checkbox.displayName = 'Checkbox'

export { Checkbox, checkboxVariants }
